<template>
<b-col sm="2">
  <b-card
    @click="select(item)"
    :style="{ cursor: 'pointer'}"
    no-body style="max-width: 20rem;"
    img-alt="site screenshot"
    img-top>
  <template v-slot:header>
    <span>
      <a v-if="item && item.config && item.config.seeds.length > 0" target="_blank" :href="item.config.seeds[0]" class="card-link">
        <b-img src="img/goto_site.png" alt="new Site" v-bind="{ width: 12, height: 12 }" style="margin:2px;"></b-img>
        <!-- <hr> -->
        <!-- <i class="fa fa-share"></i> -->
        # {{index+1}}
        {{item.fqdn}}
      </a>
      <span v-else>{{item.fqdn}} </span>
    </span>
  </template>
    <b-card-body class="text-center">
      <!-- <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title> -->
      <!-- <b-card-text> asd </b-card-text> -->

      <span v-if="loading">
        <div :class="`spinner-grow ${colors[item.id % colors.length]}`" role="status">
        </div>
      </span>
      <b-card-img class="animated fadeIn" v-else :src="item.img ? item.img : img" alt="Image" bottom></b-card-img>
      <!-- <b-card-img v-else src= alt="Image" bottom></b-card-img> -->
      <!-- <b-card-text v-else>
        <b-img src="img/no-image.png" width="80%" alt="no have latest scanning image"></b-img>
      </b-card-text> -->
    </b-card-body>

    <b-list-group flush class="text-center">
      <b-list-group-item>
        <span v-if="item.last_visit">{{item.last_visit | sdate}}</span>
        <span v-else>Ready</span>
      </b-list-group-item>
      <!-- <b-list-group-item>
        <span v-if="item.finished_at">{{item.finished_at | sdate}}</span>
        <span v-else></span>
      </b-list-group-item> -->
    </b-list-group>

    <b-card-footer v-if="item" class="text-center">
      <h4>
        <b-button variant="danger" v-if="item.detect_count > 0">
          Danger <b-badge variant="light">{{item.detect_count}}</b-badge>
        </b-button>
        <b-button variant="dark" v-if="item.page_count < 1">
          Inspection Failed
        </b-button>
        <b-badge v-else-if="!item.finished_at" variant="success">Inspecting </b-badge>
        <b-badge v-else variant="success">Safety</b-badge>
        <b-button variant="warning" v-if="item.error_count > 0">
          Error <b-badge variant="light">{{item.error_count}}</b-badge>
        </b-button>


      </h4>
    </b-card-footer>
  </b-card>
  </b-col>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
